import { useState } from 'react';
import { adminApi } from '../../utils/api';
import { toast } from '../../components/Toast';
import Icon from '../../components/Icon';

// קונסיסטנטיות קטלוג — an Excel export of catalog coding mismatches across
// every restaurant. A tab on לטיפול (owner, 27/09/2026): each row of the file
// is something to fix, so it belongs with the rest of the work backlog rather
// than on the בריאות reference screen it used to share with the duplicates
// panel.
//
// The old admin page fired this unawaited with no loading state and no failure
// path: a failed export was completely silent, and the button didn't say what
// the file contained.
export default function CatalogConsistency() {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      await adminApi.exportCatalogConsistency();
      toast('הדוח הורד');
    } catch (err) {
      toast(err.response?.data?.error || 'הפקת הדוח נכשלה — אפשר לנסות שוב', 'error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className="cc-card-head">
        <h2 className="cc-card-title">קונסיסטנטיות קטלוג</h2>
        <span className="cc-muted" style={{ fontSize: '0.79rem' }}>דוח אקסל, כל המסעדות</span>
      </div>
      <p className="cc-health-copy">
        קובץ אקסל עם אי-התאמות בקידוד הקטלוג, לכל המסעדות: גיליון אחד לשם מוצר זהה עם מקטים שונים,
        וגיליון שני למקט זהה עם שמות מוצר שונים. אי-התאמות כאלה מפצלות מוצר אחד לשניים בניתוח הרכש.
      </p>
      <button className="btn btn-outline btn-sm" onClick={run} disabled={busy}>
        <Icon name="spreadsheet" size={15} /> {busy ? 'מפיק דוח…' : 'הורדת דוח קונסיסטנטיות קטלוג'}
      </button>
    </>
  );
}
